<template>
    <div class="main">
        <div class="sample_div1">
            <!-- <div style="width: 100%;"><span>未完成</span></div> -->
            <el-button size="medium" @click="xmgl = true" style="width: 100%;">样机管理</el-button>
            <div class="sample_table1">
                <el-table :data="tableData" style="width: 100%" :show-header="false" height="100%"
                    @row-contextmenu="rightclick">
                    <el-table-column width="15">
                        <!-- <template slot-scope="scope" >
                                <div>
                                    <el-avatar size="large">
                                        <p style="font-size: 3px;">{{ scope.row.name }}</p>
                                    </el-avatar>
                                </div>
                            </template> -->
                    </el-table-column>
                    <el-table-column prop="样机型号" label="标题" width="220">
                        <template slot-scope="scope">
                            <div slot="reference" class="name-wrapper" @click="jojo(scope.row)" style="padding-top: 5px;">
                                {{ scope.row.样机型号 }}
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            
            <el-drawer title="样机管理" :visible.sync="xmgl" direction="rtl" size="45%">
                <el-button size="medium" @click="xm_add" style="width: 100px;margin-left : 25px;">新增样机</el-button>
                <div style="margin-left : 25px;margin-top: 10px"><el-table :data="tableData" border style="width: 95%"
                        height="450px">
                        <el-table-column property="登记时间" label="登记时间" width="150">
                            <template slot-scope="scope">
                                {{ scope.row.创建时间 }}
                            </template>
                        </el-table-column>
                        <el-table-column property="操作" label="操作" width="110">
                            <template slot-scope="scope">
                                {{ scope.row.操作 }}
                            </template>
                        </el-table-column>
                        <el-table-column property="样机型号" label="样机型号" width="150">
                            <template slot-scope="scope">
                                {{ scope.row.样机型号 }}
                            </template>
                        </el-table-column>
                        <el-table-column property="样机版本" label="样机版本" width="150">
                            <template slot-scope="scope">
                                {{ scope.row.样机版本 }}
                            </template>
                        </el-table-column>
                        <el-table-column property="数量" label="数量" width="108">
                            <template slot-scope="scope">
                                {{ scope.row.数量 }}
                            </template>
                        </el-table-column>
                        <el-table-column property="备注" label="备注" >
                            <template slot-scope="scope">
                                {{ scope.row.备注 }}
                            </template>
                        </el-table-column>

                        <el-table-column fixed="right" label="操作" width="100">
                            <template #default="{ row }">
                                <el-dropdown @command="command => handleSelect_2(row, command)">
                                    <el-button size="small">
                                        操作 <i class="el-icon-arrow-down el-dropdown__icon"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item command="删除">删除</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                        </el-table-column>
                    </el-table></div>
            </el-drawer>
        </div>
        <div class="sample_div1">
            <div class="sample_table11">
                <el-table :data="tableData11" style="width: 100%" :show-header="false" height="100%"
                    @row-contextmenu="rightclick">
                    <el-table-column width="15">
                        <!-- <template slot-scope="scope" >
                                <div>
                                    <el-avatar size="large">
                                        <p style="font-size: 3px;">{{ scope.row.name }}</p>
                                    </el-avatar>
                                </div>
                            </template> -->
                    </el-table-column>
                    <el-table-column prop="样机版本" label="标题" width="220">
                        <template slot-scope="scope">
                            <div slot="reference" class="name-wrapper" @click="jojo11(scope.row)" style="padding-top: 5px;">
                                {{ scope.row.样机版本 }}
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="sample_table2" v-if="this.jojo_project1 != ''">
            <el-button size="medium" @click="add_data_in" style="width: 120px;">新增登记</el-button>
            <span> {{ this.jojo_project1 }}</span>
            <div class="sample_table3">
                <el-table :data="tableData1" style="width: 580%" height="100%" border>
                    <el-table-column prop="领取时间" label="领取时间" width="168">
                        <template slot-scope="scope">
                            <div slot="reference" class="name-wrapper" style="padding-top: 5px;">
                                {{ scope.row.创建时间 }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="样机型号" label="样机型号" width="108">
                        <template slot-scope="scope">
                            <div slot="reference" class="name-wrapper" style="padding-top: 5px;">
                                {{ scope.row.样机型号 }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="用途" label="用途" width="208">
                        <template slot-scope="scope">
                            <div slot="reference" class="name-wrapper" style="padding-top: 5px;">
                                {{ scope.row.用途 }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="领取数量" label="领取数量" width="100">
                        <template slot-scope="scope">
                            <div slot="reference" class="name-wrapper" style="padding-top: 5px;">
                                {{ scope.row.领取数量 }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="领取人" label="领取人" width="108">
                        <template slot-scope="scope">
                            <div slot="reference" class="name-wrapper" style="padding-top: 5px;">
                                {{ scope.row.领取人 }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="归还时间" label="归还时间" width="168">
                        <template slot-scope="scope">
                            <div slot="reference" class="name-wrapper" style="padding-top: 5px;">
                                {{ scope.row.归还时间 }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="转让至他人" label="转让至他人" width="108">
                        <template slot-scope="scope">
                            <div slot="reference" class="name-wrapper" style="padding-top: 5px;">
                                {{ scope.row.转让至他人 }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="转让时间" label="转让时间" width="168">
                        <template slot-scope="scope">
                            <div slot="reference" class="name-wrapper" style="padding-top: 5px;">
                                {{ scope.row.转让时间 }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="备注" label="备注" width="208">
                        <template slot-scope="scope">
                            <div slot="reference" class="name-wrapper" style="padding-top: 5px;">
                                {{ scope.row.备注 }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="100">
                        <template #default="{ row }">
                            <el-dropdown @command="command => handleSelect_1(row, command)">
                                <el-button size="small">
                                    操作 <i class="el-icon-arrow-down el-dropdown__icon"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown" v-if="row.转让状态 == '未转让'">
                                    <el-dropdown-item command="转让至他人">转让至他人</el-dropdown-item>
                                    <el-dropdown-item command="删除">删除</el-dropdown-item>
                                </el-dropdown-menu>
                                <el-dropdown-menu slot="dropdown" v-else>
                                    <el-dropdown-item command="删除">删除</el-dropdown-item>
                                </el-dropdown-menu>

                            </el-dropdown>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <el-dialog :title="title" :visible="dialogVisible1" width="30%" :before-close="handleClose3">
            <el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" label-position="left">
                <el-form-item label="关联项目" prop="关联项目">
                    <el-input v-model="form.关联项目" autocomplete="off" style="width: 47%;" :disabled="true"></el-input>
                </el-form-item>   
                <el-form-item label="硬件版本号" prop="硬件版本号">
                    <el-input v-model="form.硬件版本号" autocomplete="off" style="width: 47%;"
                        placeholder="若没有请写上‘无’"></el-input>
                </el-form-item>
                <el-form-item label="软件版本号" prop="软件版本号">
                    <el-input v-model="form.软件版本号" autocomplete="off" style="width: 47%;"
                        placeholder="若没有请写上‘无’"></el-input>
                </el-form-item>
                <el-form-item label="结构版本号" prop="结构版本号">
                    <el-input v-model="form.结构版本号" autocomplete="off" style="width: 47%;"
                        placeholder="若没有请写上‘无’"></el-input>
                </el-form-item>
                <el-form-item label="版本说明" prop="版本说明">
                    <el-input v-model="form.版本说明" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="备注">
                    <el-input type="textarea" :rows="2" v-model="form.备注" autocomplete="off" placeholder="若没有备注请写上‘无’" />
                </el-form-item>
                <el-form-item label="新建人" prop="新建人">
                    <el-select v-model="form.新建人" placeholder="新建人">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="add_bb" :loading="isSending_add_bb">新建</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="title" :visible="dialogVisible2" width="30%" :before-close="handleClose2">
            <el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" label-position="left">
                <el-form-item label="关联项目" prop="关联项目">

                    <el-input v-model="form.关联项目" autocomplete="off" style="width: 47%;" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="硬件版本号" prop="硬件版本号">

                    <el-input v-model="form.硬件版本号" autocomplete="off" style="width: 47%;"></el-input>
                </el-form-item>
                <el-form-item label="软件版本号" prop="软件版本号">

                    <el-input v-model="form.软件版本号" autocomplete="off" style="width: 47%;"></el-input>
                </el-form-item>
                <el-form-item label="结构版本号" prop="结构版本号">

                    <el-input v-model="form.结构版本号" autocomplete="off" style="width: 47%;"></el-input>
                </el-form-item>
                <el-form-item label="版本说明" prop="版本说明">

                    <el-input v-model="form.版本说明" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="新建人" prop="新建人">

                    <el-select v-model="form.新建人" placeholder="新建人">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="update_bb_ing" :loading="isSending_update_bb_ing">修改</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="title" :visible="dialogVisible" width="30%" :before-close="handleClose1">
            <el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" label-position="left">
                <el-form-item label="样机型号" prop="样机型号">
                    <el-input v-model="form.样机型号" autocomplete="off" style="width: 47%;"></el-input>
                </el-form-item>
                <el-form-item label="样机版本" prop="样机版本">
                    <el-input v-model="form.样机版本" autocomplete="off" style="width: 47%;"></el-input>
                </el-form-item>
                <el-form-item label="立项时间" prop="立项时间">
                    <el-date-picker v-model="form.创建时间" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="操作" prop="操作">
                    <el-select v-model="form.操作" placeholder="操作">
                        <el-option v-for="item in xmjz" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="数量" prop="数量">
                    <el-input v-model="form.数量" autocomplete="off" style="width: 47%;"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="备注">
                    <el-input type="textarea" :rows="2" v-model="form.备注" autocomplete="off" placeholder="若没有备注请写上‘无’" />
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="add_project" :loading="isSending_project">新建</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="title" :visible="dialogVisible_datain" width="30%" :before-close="handleClose_datain">
            <el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" label-position="left">
                <el-form-item label="样机型号" prop="样机型号">
                    <el-input v-model="form.样机型号" autocomplete="off" style="width: 47%;" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="样机版本" prop="样机版本">
                    <el-input v-model="form.样机版本" autocomplete="off" style="width: 47%;" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="用途" prop="用途">
                    <el-input v-model="form.用途" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="领取数量" prop="领取数量">
                    <el-input v-model="form.领取数量" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="领取人" prop="领取人">
                    <el-select v-model="form.领取人" placeholder="领取人">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="归还时间" prop="归还时间">
                    <el-date-picker v-model="form.归还时间" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="备注" prop="备注">
                    <el-input type="textarea" :rows="2" v-model="form.备注" autocomplete="off" placeholder="若没有备注请写上‘无'" />
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="add_datain" :loading="isSending_add_datain">新建</el-button>
            </span>
        </el-dialog>


        <el-dialog :title="title" :visible="dialogVisible_position" width="30%" :before-close="handleClose_position">
            <el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" label-position="left">
                <el-form-item label="仓位" prop="仓位">
                    <el-select v-model="filterText" placeholder="选择仓位" filterable>
                        <el-option v-for="item in ware" :key="item.存放位置value" :label="item.存放位置key" :value="item.存放位置value">
                        </el-option>
                    </el-select>
                    <el-button style="margin-left: 5px;" @click="local_d" :loading="isSending9">仓位删除</el-button>
                </el-form-item>
                <el-form-item label="仓位" prop="仓位">
                    <el-input placeholder="仓位增添" v-model="warehouse_d" style="margin-right: 5px;width: 45%;">
                    </el-input>
                    <el-button style="margin-left: 5px;" @click="local_add" :loading="isSending8">仓位增添</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>


        <el-dialog :title="title" :visible="dialogVisible_datain_up" width="30%" :before-close="handleClose_datain_up">
            <el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" label-position="left">
                <el-form-item label="关联项目" prop="关联项目">
                    <el-input v-model="form.关联项目" autocomplete="off" style="width: 47%;" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="样品提供方" prop="样品提供方">
                    <el-input v-model="form.样品提供方" autocomplete="off" style="width: 47%;"></el-input>
                </el-form-item>
                <el-form-item label="硬件版本号" prop="硬件版本号">
                    <el-select v-model="form.硬件版本Id" @change="handleVersionChange($event, '硬件')" style="width: 47%;">
                        <el-option v-for="item in data_bbgl" :key="'hardware-' + item.id" :label="item.硬件版本号"
                            :value="item.id"> <!-- value 改为 item.id -->
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="软件版本号" prop="软件版本号">
                    <el-select v-model="form.软件版本Id" @change="handleVersionChange($event, '软件')" style="width: 47%;">
                        <el-option v-for="item in data_bbgl" :key="'software-' + item.id" :label="item.软件版本号"
                            :value="item.id"> <!-- value 改为 item.id -->
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="结构版本号" prop="结构版本号">
                    <el-select v-model="form.结构版本Id" @change="handleVersionChange($event, '结构')" style="width: 47%;">
                        <el-option v-for="item in data_bbgl" :key="'structure-' + item.id" :label="item.结构版本号"
                            :value="item.id"> <!-- value 改为 item.id -->
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="入库数量" prop="入库数量">
                    <el-input v-model="form.入库数量" autocomplete="off" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="入库人" prop="入库人">
                    <el-select v-model="form.入库人" placeholder="入库人">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" prop="备注">
                    <el-input v-model="form.备注" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="up_datain" :loading="isSending_up_datain">编辑</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="title" :visible="dialogVisible_file" width="25%" :before-close="handleClose_file">
            <el-form :model="form" status-icon :rules="rules" ref="form" label-width="110px" label-position="left"
                :inline="true">
                <el-form-item>
                    <el-upload style="width: 195px;" class="upload-demo1" ref="upload" :file-list="fileList" action
                        :http-request="httpRequest" :auto-upload="false">
                        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                        <el-button style="margin-left: 10px;" size="small" type="success" :loading="isSending_register"
                            @click="register('form')">上传到服务器</el-button>
                        <div slot="tip" class="el-upload__tip1" style="font-size: 11px;">选取文件后点击上传服务器上传文件(文件名不可含有空格和特殊符号)
                        </div>
                    </el-upload>
                </el-form-item>
                <el-form-item>
                    <el-popover placement="right" width="550" trigger="click">
                        <el-table :data="fileData" max-height="500px">
                            <el-table-column width="200" property="文件名称" label="文件名称"></el-table-column>
                            <el-table-column width="150" property="上传时间" label="上传时间"></el-table-column>
                            <el-table-column width="150" property="下载">
                                <template slot-scope="scope">
                                    <el-button size="mini" plain type="danger" slot="reference" style="float: right;"
                                        @click="delect_load(scope.row)">删除
                                    </el-button>
                                    <el-button size="mini" plain type="primary" slot="reference"
                                        style="float: right;margin-right: 5px;" @click="download(scope.row)">下载</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-button type="primary" slot="reference" plain
                            style="margin-left: 80%;height: 50px;">下载附件</el-button>
                    </el-popover>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog :title="title" :visible="dialogVisible_done" width="30%" :before-close="handleClose_done">
            <el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" label-position="left">
                <el-form-item label="转让至" prop="转让至">
                    <el-select v-model="form.转让至" placeholder="转让至">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="project_done" :loading="isSending_done">确认转让</el-button>
            </span>
        </el-dialog>

    </div>
</template>
  
<script>
export default {
    data() {
        return {
            xmgl: false,
            bbgl: false,
            kcxq: false,
            dialogVisible: false,
            dialogVisible1: false,
            dialogVisible2: false,
            dialogVisible_done: false,
            dialogVisible_file: false,
            dialogVisible_position: false,
            dialogVisible_datain: false,
            dialogVisible_datain_up: false,
            isSending_project: false,
            isSending_update_bb_ing: false,
            isSending_add_bb: false,
            isSending_register: false,
            isSending_add_datain: false,
            isSending_up_datain: false,
            isSending9: false,
            isSending8: false,
            isSending_done: false,
            title: '',
            project: '',
            filterText: '',
            tableData: [],
            tableData1: [],
            data_bbgl: [],
            fileList: [],
            fileData: [],
            data_kcxq: [],
            jojo_project: '',
            jojo_project1: '',
            warehouse_d: '',
            ware: [],
            options: [{
                value: '李健东',
                label: '李健东'
            }, {
                value: '温智超',
                label: '温智超'
            }, {
                value: '陈志芳',
                label: '陈志芳'
            }, {
                value: '李兆轩',
                label: '李兆轩'
            }, {
                value: '张梅丽',
                label: '张梅丽'
            }, {
                value: '罗航',
                label: '罗航'
            }, {
                value: '张莉敏',
                label: '张莉敏'
            }, {
                value: '卢凤颖',
                label: '卢凤颖'
            }, {
                value: '林宝玲',
                label: '林宝玲'
            }, {
                value: '周才德',
                label: '周才德'
            }, {
                value: '郭诗艺',
                label: '郭诗艺'
            }, {
                value: '陈楚宇',
                label: '陈楚宇'
            }, {
                value: '詹波',
                label: '詹波'
            }],
            form: {},
            xmjz: [{
                value: '新增',
                label: '新增'
            }, {
                value: '减少',
                label: '减少'
            }],
        }
    },
    created() {
        this.init()
    },
    methods: {
        init() {
            this.$axios.get('/vue/sample_prototype/sample_prototype_all').then(res => {
                console.log(res);
                this.tableData = res.data
            })
                .console(error => {
                    console.log(error)
                })
        },
        bbgl_click() {
            if (this.jojo_project == '') {
                alert('请先选择项目')
                return
            }
            // this.bbgl_data()
            this.bbgl = true
            this.bbgl_data()
        },
        file_select(filename) {
            this.$axios.post('/vue/sample_manage/file_select', { name: filename }).then(res => {
                console.log(res);
                this.fileData = res.data

            })
                .console(error => {
                    console.log(error)
                    alert('发生错误:==' + error)
                })
        },
        handleVersionChange(value, type) {
            // 根据 id 找到对应的 item
            const selectedItem = this.data_bbgl.find(item => item.id === value);
            if (!selectedItem) return;

            // 更新其他两个版本号
            this.form.硬件版本Id = selectedItem.id;
            this.form.硬件版本号 = selectedItem.硬件版本号;

            this.form.软件版本Id = selectedItem.id;
            this.form.软件版本号 = selectedItem.软件版本号;

            this.form.结构版本Id = selectedItem.id;
            this.form.结构版本号 = selectedItem.结构版本号;
        },
        jojo(row) {
            this.$axios.post('/vue/sample_prototype/sample_prototype_project', { name: row.样机型号 }).then(res => {
                console.log(res);
                if (res.msg == 'success') {
                    this.tableData11 = res.data
                    this.jojo_project = row.样机型号
                } else {
                    this.jojo_project = row.样机型号
                }
            })
                .console(error => {
                    console.log(error)
                    alert('发生错误:==' + error)
                })
        },
        jojo11(row) {
            this.$axios.post('/vue/sample_prototype/sample_prototype_project_bb', { name: row.样机版本 }).then(res => {
                console.log(res);
                if (res.msg == 'success') {
                    this.tableData1 = res.data
                    this.jojo_project1 = row.样机版本
                } else {
                    this.jojo_project1 = row.样机版本
                }
            })
                .console(error => {
                    console.log(error)
                    alert('发生错误:==' + error)
                })
        },
        jojo1() {
            this.$axios.post('/vue/sample_prototype/sample_prototype_project_bb', { name: this.jojo_project1 }).then(res => {
                console.log(res);
                this.tableData1 = res.data
            })
                .console(error => {
                    console.log(error)
                    alert('发生错误:==' + error)
                })
        },
        bbgl_data() {
            this.$axios.post('/vue/sample_manage/bbgl_data', { project: this.jojo_project }).then(res => {
                console.log(res);
                this.data_bbgl = res.data
            })
                .console(error => {
                    console.log(error)
                    alert('发生错误:==' + error)
                })
        },
        handleSelect_2(row, command) {
            console.log('选中行内容:', row);
            console.log('选中选项:', command);
            if (command == '标记为预研') {
                this.update_yuyan(row)
            } else if (command == '标记为研发中') {
                this.update_yanfa(row)
            } else if (command == '标记为开发完成') {
                this.update_kaifa(row)
            } else if (command == '删除') {
                this.project_update_delete(row)
            }
        },
        handleSelect_1(row, command) {
            console.log('选中行内容:', row);
            console.log('选中选项:', command);
            if (command == '编辑') {
                this.update_datain(row)
            }else if (command == '转让至他人') {
                this.project_data_done(row)
            } else if (command == '删除') {
                this.project_data_delete(row)
            }
        },
        project_details() {
            this.kcxq = true
            this.project_details_select()
        },
        project_details_select() {
            this.$axios.post('/vue/sample_manage/project_details_select', { name: this.jojo_project }).then(res => {
                console.log(res);
                this.data_kcxq = res.data
            })
                .console(error => {
                    console.log(error)
                    alert('发生错误:==' + error)
                })
        },
        project_data_done(row) {
            this.title = '转让至他人'
            this.form = {}
            this.form = row
            this.dialogVisible_done = true
        },
        data_file(row) {
            this.title = '附件上传下载'
            this.dialogVisible_file = true
            this.file_select(row.关联项目)
        },
        update_datain(row) {
            this.title = '编辑入库详情'
            this.form = {}
            this.form = row
            this.dialogVisible_datain_up = true
            this.ware_select()
        },
        add_position() {
            if (this.jojo_project == '') {
                alert('请先选择项目')
                return
            }
            this.title = '编辑存放位置'
            this.form = {}
            this.dialogVisible_position = true
            this.ware_select()
        },
        ware_select() {
            this.$axios.post('/vue/sample_manage/ware_select', { name: this.jojo_project }).then(res => {
                console.log(res);
                this.ware = res.data
            })
                .console(error => {
                    console.log(error)
                    alert('发生错误:==' + error)
                })
        },
        project_update_delete(row) {
            this.$confirm('此操作将该项目删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: '删除成功!请刷新页面'
                })
                this.$axios.post('/vue/sample_manage/project_update_delete', row).then(res => {
                    console.log(res)
                    this.init()
                })
                    .console(error => {
                        console.log(error)
                        alert('发生错误:==' + error)
                    })
            }).console(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                })
            })
        },
        project_data_delete(row) {
            this.$confirm('此操作将该项目删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                })
                this.$axios.post('/vue/sample_manage/project_data_delete', row).then(res => {
                    console.log(res)
                    this.jojo1()
                })
                    .console(error => {
                        console.log(error)
                        alert('发生错误:==' + error)
                    })
            }).console(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                })
            })
        },
        update_yuyan(row) {
            this.$axios.post('/vue/sample_manage/update_yuyan', row).then(res => {
                console.log(res);
                if (res.code == 200) {
                    let _this = this
                    this.$notify.success({
                        title: '更改成功',
                        message: res.msg,
                        duration: 2000,
                        onClose: function () { _this.handleClose1() }
                    });
                } else {
                    this.$notify.error({
                        title: '错误',
                        message: res.msg,
                        duration: 2000
                    });
                }
            })
                .console(error => {
                    console.log(error)
                })
        },
        update_yanfa(row) {
            this.$axios.post('/vue/sample_manage/update_yanfa', row).then(res => {
                console.log(res);
                if (res.code == 200) {
                    let _this = this
                    this.$notify.success({
                        title: '更改成功',
                        message: res.msg,
                        duration: 2000,
                        onClose: function () { _this.handleClose1() }
                    });
                } else {
                    this.$notify.error({
                        title: '错误',
                        message: res.msg,
                        duration: 2000
                    });
                }
            })
                .console(error => {
                    console.log(error)
                })
        },
        update_kaifa(row) {
            this.$axios.post('/vue/sample_manage/update_kaifa', row).then(res => {
                console.log(res);
                if (res.code == 200) {
                    let _this = this
                    this.$notify.success({
                        title: '更改成功',
                        message: res.msg,
                        duration: 2000,
                        onClose: function () { _this.handleClose1() }
                    });
                } else {
                    this.$notify.error({
                        title: '错误',
                        message: res.msg,
                        duration: 2000
                    });
                }
            })
                .console(error => {
                    console.log(error)
                })
        },
        update_bb_ing() {
            this.isSending_update_bb_ing = true
            this.$axios.post('/vue/sample_manage/update_bb_ing', this.form).then(res => {
                console.log(res);
                if (res.code == 200) {
                    this.isSending_update_bb_ing = false
                    let _this = this
                    this.$notify.success({
                        title: '更改成功',
                        message: res.msg,
                        duration: 2000,
                        onClose: function () { _this.handleClose2() }
                    });
                } else {
                    this.isSending_update_bb_ing = false
                    this.$notify.error({
                        title: '错误',
                        message: res.msg,
                        duration: 2000
                    });
                }
            })
                .console(error => {
                    console.log(error)
                    alert('请检查是否填写完整' + error)
                    this.isSending_update_bb_ing = false
                })
        },
        delete_bb(row) {
            this.$axios.post('/vue/sample_manage/delete_bb', row).then(res => {
                console.log(res)
                if (res.code == 200) {
                    let _this = this
                    this.$notify.success({
                        title: '删除成功',
                        message: res.msg,
                        duration: 2000,
                        onClose: function () { _this.handleClose3() }
                    });
                } else {
                    this.$notify.error({
                        title: '错误',
                        message: res.msg,
                        duration: 2000
                    });
                }
            })
                .console(error => {
                    console.log(error)
                    alert('发生错误:==' + error)
                })
        },
        add_project() {
            this.isSending_project = true
            console.log(this.form);
            this.$axios.post(`/vue/sample_prototype/sample_prototype_add_project`, this.form).then(res => {
                if (res.code == 200) {
                    let _this = this
                    this.$notify.success({
                        title: '成功',
                        message: res.msg,
                        duration: 2000,
                        onClose: function () { _this.handleClose1() }
                    });
                    this.isSending_project = false
                } else {
                    this.$notify.error({
                        title: '错误',
                        message: res.msg,
                        duration: 2000
                    });
                    this.isSending_project = false
                }
            }).catch(error => {
                console.log(error)
                alert('请检查是否填写完整' + error)
                this.isSending_project = false
            })
        },
        xm_add() {
            this.form = {}
            this.title = '新增样机'
            this.dialogVisible = true
        },
        add_data_in() {
            if (this.jojo_project == '' || this.jojo_project1 == '') {
                alert('请先选择样机的型号和版本')
                return
            }
            this.title = '新增登记'
            this.form = {}
            this.form.样机型号 = this.jojo_project
            this.form.样机版本 = this.jojo_project1
            this.dialogVisible_datain = true
        },
        bb_add() {
            if (this.jojo_project == '') {
                alert('请先选择项目')
                return
            }
            this.form = {}
            this.form.关联项目 = this.jojo_project
            this.title = '新增版本---' + this.jojo_project
            this.dialogVisible1 = true
        },
        add_bb() {
            this.isSending_add_bb = true
            console.log(this.form);
            this.$axios.post(`/vue/sample_in/sample_add_bb`, this.form).then(res => {
                if (res.code == 200) {
                    let _this = this
                    this.$notify.success({
                        title: '成功',
                        message: res.msg,
                        duration: 2000,
                        onClose: function () { _this.handleClose3() }
                    });
                    this.isSending_add_bb = false
                } else {
                    this.$notify.error({
                        title: '错误',
                        message: res.msg,
                        duration: 2000
                    });
                    this.isSending_add_bb = false
                }
            }).catch(error => {
                console.log(error)
                alert('请检查是否填写完整' + error)
                this.isSending_add_bb = false
            })
        },
        add_datain() {
            this.isSending_add_datain = true
            console.log(this.form);
            this.$axios.post(`/vue/sample_protptype/sample_protptype_add_datain`, this.form).then(res => {
                if (res.code == 200) {
                    let _this = this
                    this.$notify.success({
                        title: '添加成功',
                        message: res.msg,
                        duration: 2000,
                        onClose: function () { _this.handleClose_datain() }
                    });
                    this.isSending_add_datain = false
                } else {
                    this.$notify.error({
                        title: '错误',
                        message: res.msg,
                        duration: 2000
                    });
                    this.isSending_add_datain = false
                }
            }).catch(error => {
                console.log(error)
                alert('请检查是否填写完整' + error)
                this.isSending_add_datain = false
            })
        },
        up_datain() {
            this.isSending_up_datain = true
            this.$axios.post('/vue/sample_manage/up_datain', this.form).then(res => {
                console.log(res);
                if (res.code == 200) {
                    this.isSending_up_datain = false
                    let _this = this
                    this.$notify.success({
                        title: '更改成功',
                        message: res.msg,
                        duration: 2000,
                        onClose: function () { _this.handleClose_datain_up() }
                    });
                } else {
                    this.isSending_up_datain = false
                    this.$notify.error({
                        title: '错误',
                        message: res.msg,
                        duration: 2000
                    });
                }
            })
                .console(error => {
                    console.log(error)
                    alert('请检查是否填写完整' + error)
                    this.isSending_up_datain = false
                })
        },
        project_done() {
            this.isSending_done = true
            this.$axios.post('/vue/sample_prototype/prototype_done', this.form).then(res => {
                console.log(res);
                if (res.code == 200) {
                    this.isSending_done = false
                    let _this = this
                    this.$notify.success({
                        title: '确认成功',
                        message: res.msg,
                        duration: 2000,
                        onClose: function () { _this.handleClose_done() }
                    });
                } else {
                    this.isSending_done = false
                    this.$notify.error({
                        title: '错误',
                        message: res.msg,
                        duration: 2000
                    });
                }
            })
                .console(error => {
                    console.log(error)
                    alert('请检查是否填写完整' + error)
                    this.isSending_done = false
                })
        },
        update_bb(row) {
            this.title = '修改版本'
            this.form = {}
            this.form = row
            this.dialogVisible2 = true
        },
        delect_load(row) {
            this.$axios.post(`/vue/sample_manage/de[lect_load`, { name: row.项目名称, filename: row.文件名称 }).then(res => {
                if (res.code == 200) {
                    let _this = this
                    this.$notify.success({
                        title: '成功',
                        message: res.msg,
                        duration: 2000,
                    });
                } else {
                    this.$notify.error({
                        title: '错误',
                        message: res.msg,
                        duration: 2000
                    });
                }
                this.file_select(row.项目名称)
            }).console(error => {
                console.log(error)
                alert('发生错误:==' + error)
            })
        },
        handleClose() {
            this.dialogVisible = false
        },
        handleClose1() {
            this.dialogVisible = false
            this.init()
        },
        handleClose2() {
            this.dialogVisible2 = false
            this.bbgl_data()
        },
        handleClose_datain() {
            this.dialogVisible_datain = false
            this.jojo1()
        },
        handleClose_done() {
            this.dialogVisible_done = false
            this.jojo1()
        },
        handleClose_position() {
            this.dialogVisible_position = false
        },
        handleClose_datain_up() {
            this.dialogVisible_datain_up = false
            this.jojo1()
        },
        handleClose3() {
            this.dialogVisible1 = false
            this.bbgl_data()
        },
        handleClose_file() {
            this.dialogVisible_file = false
        },
        download(row) {
            console.log(row)
            let url = "https://kebeidianzi.com/vue/sample_manage/sample_manage_download/" + encodeURIComponent(row.文件名称) + "?name=" + encodeURIComponent(row.项目名称)
            this.$axios.get(`/vue/sample_manage/sample_manage_download/` + row.文件名称, { params: { name: row.加工名称 }, responseType: 'blob' }).catch(error => {
                console.log("错误", error)
                // alert('下载发生错误:==' + error)
            })
            window.open(url, '_blank')
        },
        register(formName) {
            this.$refs[formName].validate(jojo => {
                if (jojo) {
                    console.log("有效")
                    this.$refs.upload.submit()
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        httpRequest(param) {
            this.isSending_register = true
            let fileObj = param.file; // 相当于input里取得的files
            let data = new FormData(); // FormData 对象
            data.append("file", fileObj); // 文件对象
            data.append("name", this.jojo_project);
            this.$axios.post('/vue/sample_manage/sample_manage_upload', data, {
                headers: { 'Content-Type': 'multipart/form-data' }
            }).then(res => {
                if (res.code == 200) {
                    console.log("结果：", res);
                    alert('上传成功')
                } else {
                    alert('上传失败')
                }
                this.isSending_register = false
                this.fileList = []
                this.file_select(this.jojo_project)
            }).console(error => {
                console.log("错误：", error);
                alert('发生错误:==' + error)
            });
        },
        local_d() {
            if (this.filterText == '') {
                alert('请先选择仓位')
            } else {
                this.isSending9 = true
                this.$axios.post('/vue/sample_manage/local_d', { cw: this.filterText, name: this.jojo_project }).then(res => {
                    console.log(res)
                    if (res.code == 200) {
                        alert('删除成功')
                    } else {
                        alert('删除失败')
                    }
                    this.filterText = ''
                    this.isSending9 = false
                    this.ware_select()
                }).catch(error => {
                    console.log(error)
                    // alert(error)
                    this.isSending9 = false
                })
            }
        },
        local_add() {
            if (this.warehouse_d == '') {
                alert('请先输入仓位')
            } else {
                this.isSending8 = true
                this.$axios.post('/vue/sample_manage/local_add', { name: this.jojo_project, cw: this.jojo_project + '-' + this.warehouse_d }).then(res => {
                    console.log(res)
                    if (res.code == 200) {
                        alert('添加成功')
                    } else {
                        alert('添加失败')
                    }
                    this.warehouse_d = ''
                    this.isSending8 = false
                    this.ware_select()
                }).catch(error => {
                    console.log(error)
                    // alert(error)
                    this.isSending8 = false
                })
            }
        },
    }
}
</script>
  
<style>
.main {
    height: 100%;
    width: 100%;

}

.sample_div1 {
    width: 13%;
    height: 94%;
    margin: 20px;
    float: left;
}

.sample_table1 {
    width: 100%;
    border: 1px solid rgb(207, 207, 207);
    height: 92%;
    margin-top: 10px;
    float: left;

}
.sample_table11 {
    width: 100%;
    border: 1px solid rgb(207, 207, 207);
    height: 92%;
    margin-top: 47px;
    float: left;

}

.sample_table2 {
    width: 1250px;
    height: 92%;
    margin-top: 20px;
    float: left;
    border: 1px solid red;

}

.sample_table3 {
    width: 100%;
    height: 94%;
    margin-top: 10px;


}
</style>

<style scoped="scoped">
::v-deep .warm tbody tr>td {
    background-color: rgba(236, 236, 236, 0.8);
}
</style>